import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Sparkles, FolderOpen, MessageSquare } from "lucide-react";
import { TopNav } from "@/components/TopNav";
import { Footer } from "@/components/Footer";
import { api } from "@/lib/api";

const links = [
  { to: "/studio", id: "studio", label: "Generatore Studio", icon: Sparkles },
  { to: "/lavori", id: "lavori", label: "I miei Lavori", icon: FolderOpen },
  { to: "/chat", id: "chat", label: "Messaggi", icon: MessageSquare },
];

export const useHeartbeat = () => {
  useEffect(() => {
    const beat = () => api.post("/sessions/heartbeat").catch(() => {});
    beat();
    const t = setInterval(beat, 30000);
    return () => clearInterval(t);
  }, []);
};

export default function StudentLayout() {
  useHeartbeat();
  return (
    <div className="min-h-screen bg-[#FBFBFC] flex flex-col">
      <TopNav links={links} home="/studio" sub="Studente" />
      <main className="flex-1 w-full max-w-[1400px] mx-auto px-4 sm:px-8 py-8 sm:py-12">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
